<template>
  <iframe
    allowfullscreen=""
    :style="{ 'height': getHeight }"
    scrolling="no"
    class="game-iframe"
    id="iframe"
    :src="getPath"
  />
</template>

<script>
  import { gameType } from '@/services/cards.service';
  import { closeFullscreen } from '../utils/settings.fullscreen';
  import { Events } from '@/models/analytics';

  const path = {
    puzzle: 'https://d3aod987c9rl70.cloudfront.net/webApp/games-new/puzzle_new/index.html',
    memory: 'https://d3aod987c9rl70.cloudfront.net/webApp/games-new/memory/index.html',
    color: 'https://d3aod987c9rl70.cloudfront.net/webApp/games-new/color/index.html',
    music: 'https://d3aod987c9rl70.cloudfront.net/webApp/games-new/music/index.html',
    hide: 'https://d3aod987c9rl70.cloudfront.net/webApp/games-new/hide/index.html',
    find_the_way: 'https://d3aod987c9rl70.cloudfront.net/webApp/games-new/find_the_way/index.html',
  };

  const puzzleImg = 'https://d3aod987c9rl70.cloudfront.net/gameImages/images/tablet-m/';

  export default {
    data() {
      return {
        identifier: '',
        gameType: gameType.puzzle,
        getPath: '',
        folder: '',
        position: 0,
        color: '',
        iframeIsClosed: false,
        routeBefore: '',
        height: '',
      };
    },
    computed: {
      getHeight: {
        get() {
          return this.height;
        },
      },
    },
    methods: {
      resizeIframe() {
        const y = window.innerHeight;
        this.height = `${y}px`;
      },
      receiveMessage(event) {
        if (event.data === 'close') {
          if (!this.iframeIsClosed) {
            closeFullscreen();
            this.iframeIsClosed = true;
            if (this.routeBefore && ['game'].includes(this.routeBefore)) {
              this.$router.go(-1);
            } else {
              this.$router.push({ name: 'home' });
            }
          }
        }
      },
      getImg() {
        return `${puzzleImg}${this.identifier}.png`;
      },
    },
    created() {
      this.dif = this.$route.params.dif;
      this.identifier = this.$route.params.identifier;
      this.gameType = this.$route.params.gameType;
      this.folder = this.$route.params.folder || '';
      this.position = this.$route.params.position;
      this.getPath = `${path[this.gameType]}?imgdir=${this.position}`;

      window.addEventListener('message', this.receiveMessage, false);
    },
    mounted() {
      this.resizeIframe();
      window.onresize = this.resizeIframe;
    },
    destroyed() {
      if (this.getToken !== false && localStorage.getItem('kidj_ut')) {
        this.$store.dispatch('analytics/postAnalytics', Events.CLOSE, { root: true });
        this.$store.dispatch('analytics/resetAnalyticsGameMedia', {});
      }
    },
    beforeRouteEnter(to, from, next) {
      next((vm) => vm.routeBefore = from.name ? from.name : null);
    },
  };
</script>

<style scoped lang="scss">
  .game-iframe {
    margin: auto;
    position: absolute;
    width: 1px !important;
    min-width: 100%;
    *width: 100%;
  }
</style>